import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ENV } from '../../../environment';

@Injectable()
export class StorageService {

  constructor(private cookieService: CookieService) {}

  set(key, value) {
    this.cookieService.set(key, value, undefined, '/', ENV.SuiteDomain, true, 'Lax');
    localStorage.setItem('ls.' + key, value);
  }

  get(key) {
    // the split is for cases where there are double quotes - e.g. ""string""
    let value = this.cookieService.get(key);
    if (value) {
      return value.split('"').join('');
    } else {
      value = localStorage.getItem('ls.' + key);
      if (value) {
        return value.split('"').join('');
      }
    }

    return value;
  }

  remove(key) {
    this.cookieService.delete(key, '/', ENV.SuiteDomain);
    localStorage.removeItem('ls.' + key);
  }
}
